import { render } from "./incrediDropdownMenu.vue?vue&type=template&id=61f8d5b8"
import script from "./incrediDropdownMenu.vue?vue&type=script&lang=js"
export * from "./incrediDropdownMenu.vue?vue&type=script&lang=js"

import "./incrediDropdownMenu.vue?vue&type=style&index=0&id=61f8d5b8&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QList,QItem});
